export default "__VITE_ASSET__944e73a1__"